import { ChildrenItem } from "dependencies/base"
import { Pagination } from "./model"
import { home, bs, appHome } from "./diffrence_options"
// import icon from "assets/images/leftMenu/basePortal/icon_tab.png"
import bigScreenIcon from "assets/images/leftMenu/base/cx_text.png"
let icon="icon-portal-pagination"
let cover = [
  require("assets/images/leftMenu/pagination/style1.png")
]
export let pagination_children = []
export let bs_pagination_children = []
export let app_pagination_children = []
for (let i = 0; i < home.length; i++) {
  pagination_children.push(new ChildrenItem("分页" + i, icon, "cxPagination", new Pagination(home[i]), cover[i]))
}
for (let i = 0; i < bs.length; i++) {
  bs_pagination_children.push(new ChildrenItem("分页" + i, bigScreenIcon, "cxPagination", new Pagination(bs[i])))
}
for (let i = 0; i < appHome.length; i++) {
  app_pagination_children.push(new ChildrenItem("分页" + i, icon, "cxPagination", new Pagination(appHome[i]), cover[i]))
}
